import { useState, type ReactNode } from 'react';
import {
  FormFooter,
  HelpLine,
  NoteTextarea,
  RejectChips,
} from './ai-appeal-reject-form-parts';

type Props = {
  onCancel: () => void;
  onConfirm: (adminNote: string) => void;
  isPending: boolean;
};

type BodyProps = {
  note: string;
  setNote: (v: string) => void;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

function RejectFormBody(p: BodyProps): ReactNode {
  return (
    <>
      <HelpLine />
      <RejectChips current={p.note} onPick={p.setNote} />
      <NoteTextarea value={p.note} onChange={p.setNote} />
      <FormFooter
        noteLength={p.note.length}
        isPending={p.isPending}
        onCancel={p.onCancel}
        onConfirm={p.onConfirm}
      />
    </>
  );
}

// Inline reject-appeal form. The note is optional; if empty the rejection
// still goes through. When written it lands in `appeal_admin_note` and is
// surfaced in the collector's detail view so they understand the verdict.
export function AiAppealRejectForm(props: Props): ReactNode {
  const [note, setNote] = useState('');
  return (
    <div className="flex flex-col gap-sm w-full border-t border-white/[0.06] pt-sm">
      <RejectFormBody
        note={note}
        setNote={setNote}
        isPending={props.isPending}
        onCancel={props.onCancel}
        onConfirm={() => props.onConfirm(note.trim())}
      />
    </div>
  );
}
